/**
 * Bingkai layar detail hari — MURNI.
 *
 * Layar yang sama melayani dua hal yang berbeda sejak 23 Agustus 2026: hari SENDIRI, dan hari
 * ORANG LAIN yang dibuka penyelia dari Dashboard Absensi.
 *
 * Dipisahkan dari komponen karena satu keputusan di dalamnya bersifat KESELAMATAN, bukan tata
 * letak: apakah tautan "Ajukan koreksi" boleh ditampilkan. `CorrectionNewPage` memaku
 * `subjectUserId: session.me.userId`, jadi menekan tautan itu sambil membuka hari orang lain akan
 * mengajukan koreksi pada catatan PENYELIANYA SENDIRI untuk tanggal tersebut — diam-diam, tanpa
 * galat, dan pada data absensi yang dipakai untuk keputusan kepegawaian.
 *
 * Aturan semacam itu tidak boleh hidup hanya sebagai `? :` di tengah JSX, tempat ia dapat lenyap
 * dalam satu kali perapian tanpa ada yang merah.
 */

export interface DayDetailChrome {
  readonly milikOrangLain: boolean;
  /** Tujuan tautan kembali — asal pembacanya berbeda untuk kedua peran. */
  readonly kembaliKe: string;
  readonly labelKembali: string;
  /** Benar HANYA untuk hari sendiri. Lihat alasannya di atas. */
  readonly bolehAjukanKoreksi: boolean;
}

export function dayDetailChrome(subjekUserId: string, meUserId: string): DayDetailChrome {
  /*
   * Perbandingan string apa adanya. Keduanya UUID dari sumber yang sama (`session.me.userId` dan
   * parameter rute), dan menormalkan huruf besar-kecil di sini akan MENYEMBUNYIKAN ketidakcocokan
   * yang sebenarnya menandakan bug di tempat lain.
   *
   * Bila keduanya sama — penyelia membuka harinya sendiri lewat tautan dashboard — layarnya
   * berperilaku persis seperti rute pribadi, termasuk tautan koreksinya. Itu memang benar: ia
   * sedang mengoreksi catatannya sendiri.
   */
  const milikOrangLain = subjekUserId !== meUserId;
  return {
    milikOrangLain,
    kembaliKe: milikOrangLain ? '/dashboard/attendance' : '/attendance/history',
    labelKembali: milikOrangLain ? '← Pantauan Absensi' : '← Riwayat',
    bolehAjukanKoreksi: !milikOrangLain,
  };
}
